import React, { useEffect } from 'react'
import { useReservationContext } from './ReservationContext'
import classNames from 'classnames'
import ArrowDown from '@assets/img/reservation/arrow-down.svg'
import Info from '@assets/img/reservation/info.svg'
import InfoPink from '@assets/img/reservation/info-pink.svg'
import ConsultantImg from '@assets/img/reservation/consultant.png'
import CheckboxPink from '@assets/img/reservation/checkbox-pink.svg'
import CheckboxPinkLight from '@assets/img/reservation/checkbox-pink-light.svg'
import CheckboxEmpty from '@assets/img/reservation/checkbox-empty.svg'
import Axa from '@assets/img/reservation/axa.png'
import Loader from '../search-trip/components/Loader'
import { INSURENCE_VARIANT_TYPE } from './useReservation'

const InsuranceView = () => {
    const { getInsurances, selectedInsurance, setSelectedInsurance, insuranceOffers, t } = useReservationContext()

    useEffect(() => {
        getInsurances()
    }, [])

    if (!insuranceOffers) return <Loader />

    return (
        <div>
            <div className="trip-reservation__section trip-reservation__section--full" id="insurance-section">
                <div className="trip-reservation__section-headings">
                    <div className="trip-reservation__section-heading">{t('travel-safely')}</div>
                    <div className="trip-reservation__section-subheader">{t('insurance-that-works')}</div>
                </div>
                <div className="trip-reservation__insurance-type">
                    <button
                        className={classNames('trip-reservation__btn trip-reservation__btn--insurance', {
                            'trip-reservation__btn--gray': selectedInsurance === null,
                        })}
                        onClick={() => {
                            setSelectedInsurance(insuranceOffers.calculations[1])
                        }}
                    >
                        {selectedInsurance !== null ? <img src={CheckboxPinkLight} alt="checkbox-pink" /> : null}
                        {t('with-insurance')}
                    </button>
                    <button
                        className={classNames('trip-reservation__btn trip-reservation__btn--insurance', {
                            'trip-reservation__btn--gray': selectedInsurance !== null,
                        })}
                        onClick={() => {
                            setSelectedInsurance(null)
                        }}
                    >
                        {selectedInsurance === null ? <img src={CheckboxPinkLight} alt="checkbox-pink" /> : null}
                        {t('without-insurance')}
                    </button>
                </div>
                {selectedInsurance !== null ? (
                    <div className="trip-reservation__cards">
                        {insuranceOffers && insuranceOffers.calculations && insuranceOffers.calculations.length > 0
                            ? insuranceOffers.calculations.map((insurance, i) => {
                                  const infoIcon =
                                      selectedInsurance && selectedInsurance.variant === insurance.variant
                                          ? InfoPink
                                          : Info

                                  return (
                                      <div
                                          className={classNames('trip-reservation__card', {
                                              'trip-reservation__card--selected':
                                                  selectedInsurance && selectedInsurance.variant === insurance.variant,
                                          })}
                                          key={insurance.variant}
                                          onClick={() => {
                                              setSelectedInsurance(insurance)
                                          }}
                                      >
                                          {i === 1 ? (
                                              <div className="trip-reservation__badge">{t('popular')}</div>
                                          ) : null}
                                          <div className="trip-reservation__card-content">
                                              <img
                                                  className="trip-reservation__card-circle"
                                                  src={
                                                      selectedInsurance &&
                                                      selectedInsurance.variant === insurance.variant
                                                          ? CheckboxPink
                                                          : CheckboxEmpty
                                                  }
                                                  alt="checkbox-pink"
                                              />
                                              <img className="trip-reservation__card-axa" src={Axa} alt="axa" />
                                              <div className="trip-reservation__card-header">
                                                  <div className="trip-reservation__card-heading">
                                                      {i === 0 ? t('holidaymaker') : i === 1 ? t('traveler') : t('conqueror')}
                                                  </div>
                                                  <div className="trip-reservation__card-price">
                                                      {Number(insurance.totalPrice).toFixed(2)} PLN
                                                  </div>
                                              </div>
                                              <div className="trip-reservation__card-details">
                                                  <div>
                                                      <span>  
                                                          <img
                                                              className="trip-reservation__card-info"
                                                              src={infoIcon}
                                                              alt="info"
                                                          />
                                                          {t('treatment-costs')}
                                                      </span>
                                                      <span className="trip-reservation__card-details-price">
                                                          {insurance.variant === INSURENCE_VARIANT_TYPE.REFERENCE ? "200 000" :
                                                              insurance.variant === INSURENCE_VARIANT_TYPE.KOMFORT ? "600 000" :
                                                              insurance.variant === INSURENCE_VARIANT_TYPE.EXCELENT ? "40 000 000" : "-"} PLN
                                                      </span>
                                                  </div>
                                                  <div>
                                                      <span>
                                                          <img
                                                              className="trip-reservation__card-info"
                                                              src={infoIcon}
                                                              alt="info"
                                                          />
                                                          {t('accident-insurance')}
                                                      </span>
                                                      <span className="trip-reservation__card-details-price">
                                                          {insurance.variant === INSURENCE_VARIANT_TYPE.REFERENCE ? "20 000" :
                                                              insurance.variant === INSURENCE_VARIANT_TYPE.KOMFORT ? "50 000" :
                                                                  insurance.variant === INSURENCE_VARIANT_TYPE.EXCELENT ? "150 000" : '\u2014'} PLN
                                                      </span>
                                                  </div>
                                                  <div>
                                                      <span>
                                                          <img
                                                              className="trip-reservation__card-info"
                                                              src={infoIcon}
                                                              alt="info"
                                                          />
                                                          {t('baggage-insurance')}
                                                      </span>
                                                      <span className="trip-reservation__card-details-price">
                                                          {insurance.variant === INSURENCE_VARIANT_TYPE.REFERENCE ? '\u2014' :
                                                              insurance.variant === INSURENCE_VARIANT_TYPE.KOMFORT ? "3 000" :
                                                                  insurance.variant === INSURENCE_VARIANT_TYPE.EXCELENT ? "6 000" : '\u2014'} PLN
                                                      </span>
                                                  </div>
                                                  <div>
                                                      <span>
                                                          <img
                                                              className="trip-reservation__card-info"
                                                              src={infoIcon}
                                                              alt="info"
                                                          />
                                                          {t('oc-insurance')}
                                                      </span>
                                                      <span className="trip-reservation__card-details-price">
                                                          {insurance.variant === INSURENCE_VARIANT_TYPE.REFERENCE ? '\u2014' :
                                                              insurance.variant === INSURENCE_VARIANT_TYPE.KOMFORT ? "250 000" :
                                                                  insurance.variant === INSURENCE_VARIANT_TYPE.EXCELENT ? "1 500 000" : '\u2014'} PLN
                                                      </span>
                                                  </div>
                                              </div>
                                              {/*
                                    <div className="trip-reservation__card-footer">
                                        <button className="trip-reservation__card-footer-btn">
                                            Rozwiń i porównaj <img src={ArrowDown} alt="" />
                                        </button>
                                    </div>
                                    */}
                                          </div>
                                      </div>
                                  )
                              })
                            : null}
                    </div>
                ) : (
                    <div className="trip-reservation__cards">
                        <div className="trip-reservation__card trip-reservation__card--selected trip-reservation__card--single">
                            <div className="trip-reservation__card-content">
                                <img className="trip-reservation__card-circle" src={CheckboxPink} alt="checkbox-pink" />
                                <div className="trip-reservation__card-header">
                                    <div className="trip-reservation__card-price">{t('without-insurance-risk')}</div>
                                    <div className="trip-reservation__card-heading" dangerouslySetInnerHTML={{ __html: t('estimated-costs') }}></div>
                                </div>
                                <div className="trip-reservation__card-details-two-cols">
                                    <div className="trip-reservation__card-details">
                                        <div>
                                            <span>
                                                <img
                                                    className="trip-reservation__card-info"
                                                    src={InfoPink}
                                                    alt="info"
                                                />
                                                {t('hospitalization')}
                                            </span>
                                            <span className="trip-reservation__card-details-price">
                                                1 500 - 30 000 PLN
                                            </span>
                                        </div>
                                        <div>
                                            <span>
                                                <img
                                                    className="trip-reservation__card-info"
                                                    src={InfoPink}
                                                    alt="info"
                                                />
                                                {t('dental-treatment')}
                                            </span>
                                            <span className="trip-reservation__card-details-price">700 - 2500 PLN</span>
                                        </div>
                                        <div>
                                            <span>
                                                <img
                                                    className="trip-reservation__card-info"
                                                    src={InfoPink}
                                                    alt="info"
                                                />
                                                {t('medical-transport-home')}
                                            </span>
                                            <span className="trip-reservation__card-details-price">
                                                15 000 - 40 000 PLN
                                            </span>
                                        </div>
                                        <div>
                                            <span>
                                                <img
                                                    className="trip-reservation__card-info"
                                                    src={InfoPink}
                                                    alt="info"
                                                />
                                                {t('repatriation')}
                                            </span>
                                            <span className="trip-reservation__card-details-price">
                                                15 000 - 35 000 PLN
                                            </span>
                                        </div>
                                        <div>
                                            <span>
                                                <img
                                                    className="trip-reservation__card-info"
                                                    src={InfoPink}
                                                    alt="info"
                                                />
                                                {t('general-practitioner')}
                                            </span>
                                            <span className="trip-reservation__card-details-price">500 - 1500 PLN</span>
                                        </div>
                                    </div>
                                    <div className="trip-reservation__card-details">
                                        <div>
                                            <span>
                                                <img
                                                    className="trip-reservation__card-info"
                                                    src={InfoPink}
                                                    alt="info"
                                                />
                                                {t('surgery-after-accident')}
                                            </span>
                                            <span className="trip-reservation__card-details-price">
                                                20 000 - 80 000 PLN
                                            </span>
                                        </div>
                                        <div>
                                            <span>
                                                <img
                                                    className="trip-reservation__card-info"
                                                    src={InfoPink}
                                                    alt="info"
                                                />
                                                {t('intensive-care')}
                                            </span>
                                            <span className="trip-reservation__card-details-price">
                                                8 000 - 30 000 PLN
                                            </span>
                                        </div>
                                        <div>
                                            <span>
                                                <img
                                                    className="trip-reservation__card-info"
                                                    src={InfoPink}
                                                    alt="info"
                                                />
                                                {t('diagnostic-tests')}
                                            </span>
                                            <span className="trip-reservation__card-details-price">
                                                1 000 - 9 000 PLN
                                            </span>
                                        </div>
                                        <div>
                                            <span>
                                                <img
                                                    className="trip-reservation__card-info"
                                                    src={InfoPink}
                                                    alt="info"
                                                />
                                                {t('outpatient-treatment')}
                                            </span>
                                            <span className="trip-reservation__card-details-price">
                                                800 - 3 500 PLN
                                            </span>
                                        </div>
                                        <div>
                                            <span>
                                                <img
                                                    className="trip-reservation__card-info"
                                                    src={InfoPink}
                                                    alt="info"
                                                />
                                                {t('rescue-costs')}
                                            </span>
                                            <span className="trip-reservation__card-details-price">
                                                20 000 - 60 000 PLN
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <div className="trip-reservation__terms">
                    <a href="/pdf/insurance/ALL.pdf" target="_blank" className="trip-reservation__terms-link">
                        {t('coverage')}
                    </a>
                    /
                    <a href="/pdf/insurance/OWU.pdf" target="_blank" className="trip-reservation__terms-link">
                        {t('conditions')}
                    </a>
                    /
                    <a href="/pdf/insurance/UPDO.pdf" target="_blank" className="trip-reservation__terms-link">
                        {t('brochure')}
                    </a>
                    /
                    <a href="/pdf/insurance/IPID.pdf" target="_blank" className="trip-reservation__terms-link">
                        {t('product-card')}
                    </a>
                </div>
            </div>
            <hr className="trip-reservation__divider" />
            <div className="trip-reservation__section trip-reservation__section--full">
                <div className="trip-reservation__section-headings trip-reservation__section-headings--left trip-reservation__section-headings--eyebrow">
                    <div className="trip-reservation__section-eyebrow">{t('travel-safety')}</div>
                    <div className="trip-reservation__section-heading">{t('add-insurance')}</div>
                </div>
                <div className="trip-reservation__section-content trip-reservation__section-content--two">
                    <div className="trip-reservation__section-content-left">
                        <div className="trip-reservation__section-content-subsection">
                            <div className="trip-reservation__section-content-subsection-content">
                                <div className="trip-reservation__section-content-heading"> {t('board-coverage')}</div>
                                <div className="trip-reservation__section-content-text">{t('axa-description')}</div>
                            </div>
                        </div>
                        <div className="trip-reservation__section-content-subsection">
                            <div className="trip-reservation__section-content-subsection-content">
                                <div className="trip-reservation__section-content-heading"> {t('fast-help')}</div>
                                <div className="trip-reservation__section-content-text">{t('axa-helpline')}</div>
                            </div>
                        </div>
                        <div className="trip-reservation__section-content-subsection">
                            <div className="trip-reservation__section-content-subsection-content">
                                <div className="trip-reservation__section-content-heading">{t('personalized')}</div>
                                <div className="trip-reservation__section-content-text">{t('axa-flexibility')}</div>
                            </div>
                        </div>
                        <a href="#insurance-section" className="trip-reservation__btn-link">
                            <button className="trip-reservation__btn"> {t('insure-me')}!</button>
                        </a>
                    </div>
                    <img className="trip-reservation__section-img-right" src={ConsultantImg} alt="consultant" />
                </div>
            </div>
        </div>
    )
}

export default InsuranceView
